import { myFetch, HttpMethod } from "./baseService";

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export interface TipoTablero {
  tti_codigo?: string;
  tti_nombre?: string;
  tti_estatus?: string;
  tti_estatus_nombre?: string;
}

export interface Publicacion {
  tin_codigo?: string | number;
  tin_titulo?: string;
  tin_descripcion?: string;
  tin_fecha?: string;
  tin_tipo?: string;
  tin_tipo_nombre?: string;
  tin_ruta_foto?: string;
  tin_unidad_residencial?: string;
  tin_torre?: string;
  tin_torre_nombre?: string;
  tin_apartamento?: string;
  tin_apartamento_nombre?: string;
  tin_numero_celular?: string;
  tin_republicar?: string;
  // Campos legacy para compatibilidad
  codigo?: string | number;
  tab_codigo?: string | number;
  titulo?: string;
  descripcion?: string;
  fecha_publicacion?: string;
  tipo_publicacion_codigo?: string;
  tipo_publicacion_nombre?: string;
  ruta_foto?: string;
  foto_base64?: string;
  numero_whatsapp?: string;
  unidad_residencial_codigo?: string;
  apartamento_codigo?: string;
}

export interface ObtenerPublicacionesRequest {
  codigo: string | number | "";
  unidad_residencial_codigo: string;
  apartamento_codigo: string;
  tipo_publicacion_codigo: string;
}

export interface ObtenerDetalleRequest {
  codigo: string | number;
  unidad_residencial_codigo: string;
  tipo_publicacion_codigo: string;
}

export interface ObtenerPublicacionesActivasRequest {
  codigo: string | number;
  unidad_residencial_codigo: string;
  tipo_publicacion_codigo: string;
}

export interface EliminarPublicacionRequest {
  codigo: string | number;
}

export const obtenerTiposTablero = async () => {
  const envelope = await myFetch<ApiEnvelope<TipoTablero[]>>(
    "tipo_tablero_informativo/ObtenerTodos",
    HttpMethod.POST,
    {}
  );
  return envelope;
};

export const obtenerPublicaciones = async (payload: ObtenerPublicacionesRequest) => {
  const envelope = await myFetch<ApiEnvelope<Publicacion[]>>(
    "tablero_informativo/Obtener_todas_las_publicaciones_activas",
    HttpMethod.POST,
    payload
  );
  return envelope;
};

export const obtenerPublicacionActiva = async (payload: ObtenerDetalleRequest) => {
  const envelope = await myFetch<ApiEnvelope<Publicacion[]>>(
    "tablero_informativo/Obtener_todas_las_publicaciones_activas",
    HttpMethod.POST,
    payload
  );
  return envelope;
};

export const eliminarPublicacion = async (payload: EliminarPublicacionRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "tablero_informativo/Eliminar",
    HttpMethod.POST,
    payload
  );
  return envelope;
};

